import React from "react";
import { ReactComponent as TextureUqai } from "../../assets/img/texture/corte-logo-uqai.svg";
import { ReactComponent as LogoUqai } from "../../assets/img/logo/logo-uqai.svg";
import "./prodeseg-footer.scss";

export const ProdesegFooter: React.FC = () => {
    return (
        <footer
            className={`d-none d-md-flex prodeseg-footer bg-gradient-linear-neutral-1 position-sticky bottom-0 
            justify-content-between py-1 px-4 w-100`}
        >
            <TextureUqai className="position-absolute end-0 bottom-0" height="24px" width="24px" />
            <div className="text-primary">
                <i className="far fa-copyright mr-1" />
                <span className="mr-1 d-none d-md-inline">Copyright</span>
                <span className="mr-1">{new Date().getFullYear()}</span>
                <strong>Prodeseg</strong>
            </div>
            <div>
                <span className={"text-neutral-500 font-italic"}>Designed & Developed by:</span>
                <LogoUqai className={"pl-2"} height={"18"} />
            </div>
        </footer>
    );
};
